import React, { useState, useEffect } from 'react';
import './Header.css';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'Who We Are', sectionId: 'who-we-are' },
    { label: 'Our Vision', sectionId: 'our-vision' },
    { label: 'What We Do', sectionId: 'what-we-do' },
    { label: 'How We Think', sectionId: 'how-we-think' },
    { label: 'Ventures', sectionId: 'ventures' },
    { label: 'Founders', sectionId: 'founders' },
    { label: 'Contact', sectionId: 'contact' }
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo" onClick={() => scrollToSection('hero')}>
          <div className="logo-circle">HFI</div>
          <span className="logo-text">HashFusion Innovations</span>
        </div>

        <nav className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          {menuItems.map((item, index) => (
            <button
              key={index}
              className="nav-link"
              onClick={() => scrollToSection(item.sectionId)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
